import axiosInstance from '../services/axiosInstance';
import { envUrls } from './env';

// Uncomment this to test localhost
// envUrls.partnershipsService = 'http://localhost:6059/partnerships/';

export default class PartnershipsService {
  async loadPartnerships(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}get_scan_partnerships`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async getCustomGraphs(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}get_custom_graphs`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async createCustomGraph(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}create_custom_graph`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async editCustomGraph(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}edit_custom_graph`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async deleteCustomGraph(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}delete_custom_graph`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async getInstitutions(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}get_institutions`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async getCountriesStates(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.get(
      `${envUrls.partnershipsService}get_countries_states`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
  async getEntityPartnerships(payload) {
    const headers = {
      'Content-Type': 'application/json',
    };
    const response = await axiosInstance.post(
      `${envUrls.partnershipsService}get_entity_partnerships`,
      payload,
      { headers: headers }
    );
    return response.data;
  }
}
